  <nav class="navbar navbar-expand-lg mat-elevation-z8 d-block d-sm-none">
    <div class="container-fluid d-flex justify-content-center">
      <img  src="assets/img/Logo_speakup.png" height="35px">
      <!-- <div class="d-none d-sm-block vr mx-4 my-2"></div>-->
      <!-- <span class=" my-2 rubik_global fw-bold fs-2">Wediom</span>  -->
      <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 gap-2">
          </ul>
          <form class="d-flex my-1 gap-4">
            <button *ngIf="auth" mat-raised-button color="basic" (click)="registroUsuario()" class="me-2">Comenzar gratis</button>
            <button *ngIf="auth" mat-raised-button (click)="login()" style="background-color: #FF004F; color: #fff;">Iniciar Sesión</button>
            <div class="my-1" *ngIf="auth" matTooltip="INICIO"  (click)="homeApp()" style="font-size: 1.5rem;" role="button"><i class="fa-solid fa-house"></i></div>
            <div *ngIf="auth" matTooltip="CORRECCIONES"  class="rubik_global py-1 fs-6 fw-bold" role="button">
              Repaso
            </div>
            <div *ngIf="auth" matTooltip="MI APRENDIZAJE"  class="rubik_global py-1 fs-6 fw-bold" role="button" (click)="inicioApp()">
              Aprender
            </div>
            <a *ngIf="auth" class="" [matTooltip]="nombre" role="button" (click)="perfilUsuario()">
              <img *ngIf="img" [src]="img" class="rounded-circle  border" alt="" width="30px" height="30px"> 
            </a>
            <div class="d-none d-sm-block vr " *ngIf="auth"></div>
            <div class="my-1" *ngIf="auth" matTooltip="CERRAR SESIÓN" (click)="cerrarsesion()" style="font-size: 1.5rem;" role="button"><i class="fas fa-sign-out-alt"></i></div>
          </form>
      </div> -->
    </div>
  </nav>
  <nav class="navbar navbar-expand-lg mat-elevation-z8 d-none d-sm-block">
    <div class="container-fluid px-2">
      <img  src="assets/img/Logo_speakup.png" height="35px">
      <!-- <div class="d-none d-sm-block vr mx-4 my-2"></div>-->
      <!-- <span class=" my-2 rubik_global fw-bold fs-2">Wediom</span>  -->
      <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button> -->
      <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 gap-2">
          </ul>
          <form class="d-flex my-1 gap-4">
            <button *ngIf="auth" mat-raised-button color="basic" (click)="registroUsuario()" class="me-2">Comenzar gratis</button>
            <button *ngIf="auth" mat-raised-button (click)="login()" style="background-color: #FF004F; color: #fff;">Iniciar Sesión</button>
            <div class="my-1" *ngIf="auth" matTooltip="INICIO"  (click)="homeApp()" style="font-size: 1.5rem;" role="button"><i class="fa-solid fa-house"></i></div>
            <div *ngIf="auth" matTooltip="CORRECCIONES"  class="rubik_global py-1 fs-6 fw-bold" role="button">
              Repaso
            </div>
            <div *ngIf="auth" matTooltip="MI APRENDIZAJE"  class="rubik_global py-1 fs-6 fw-bold" role="button" (click)="inicioApp()">
              Aprender
            </div>
            <a *ngIf="auth" class="" [matTooltip]="nombre" role="button" (click)="perfilUsuario()">
              <img *ngIf="img" [src]="img" class="rounded-circle  border" alt="" width="30px" height="30px"> 
            </a>
            <div class="d-none d-sm-block vr " *ngIf="auth"></div>
            <div class="my-1" *ngIf="auth" matTooltip="CERRAR SESIÓN" (click)="cerrarsesion()" style="font-size: 1.5rem;" role="button"><i class="fas fa-sign-out-alt"></i></div>
          </form>
      </div> -->
    </div>
  </nav>
